/**
 * Dialog 형 모달 — Figma 디자인 시스템의 "Type B Dialog" 패턴.
 *
 * Alert(Type A, r-16, SemiBold title)와 구분: r-24, Bold 20px title, 검정 단일 버튼.
 * 사용자가 선택할 여지 없이 결과를 통보하는 안내에 사용 (예: "지금은 취소할 수 없어요").
 *
 * description은 white-space: pre-line — 줄바꿈을 `\n`으로 직접 제어한다.
 */

import { Modal } from '@onl-web/shared/components'

import {
  DialogActions,
  DialogBackdrop,
  DialogConfirmButton,
  DialogContent,
  DialogDescription,
  DialogTextArea,
  DialogTitle,
} from './styles'

interface DialogModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  description?: string
  confirmLabel: string
  onConfirm: () => void
}

export function DialogModal({ isOpen, onClose, title, description, confirmLabel, onConfirm }: DialogModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
    >
      <DialogBackdrop>
        <DialogContent>
          <DialogTextArea>
            <DialogTitle>{title}</DialogTitle>
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogTextArea>
          <DialogActions>
            <DialogConfirmButton
              type='button'
              onClick={onConfirm}
            >
              {confirmLabel}
            </DialogConfirmButton>
          </DialogActions>
        </DialogContent>
      </DialogBackdrop>
    </Modal>
  )
}
